/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function StepperButtons({
  step,
  maxSteps,
  onStepChange,
  disabled,
}) {
  const { t } = useTranslation();

  const last = step === maxSteps;
  return (
    <div
      css={css`
        display: flex;
        gap: 1rem;
        margin-left: auto;
      `}
    >
      <Button
        onClick={() => onStepChange(step - 1)}
        startIcon={<ArrowBackIcon />}
        disabled={step === 0}
      >
        {t('Gå tillbaka')}
      </Button>
      <Button
        onClick={() => onStepChange(step + 1)}
        variant="contained"
        color="primary"
        endIcon={<ArrowForwardIcon />}
        disabled={disabled}
      >
        {last ? t('Till systemet') : t('Fortsätt')}
      </Button>
    </div>
  );
}
